module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "vol-1-chapter-21"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "vol-1-chapter-21-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-chapter-21-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("H")]), _vm._v("urried excuses were made; the three clients in the meeting room were told an emergency had arisen; apologies were duly given; an appointment was rescheduled. Now it was Fletcher sitting in the meeting room opposite Black, and completely against office policy, smoking a Marlboro Red. Black didn’t give a damn. He opened a window, and then sat, watching Fletcher inhale deep lungfuls of nicotine. Fletcher had found his voice and was now in talk overload. "), _c('i', [_vm._v("Shock")]), _vm._v(", Black thought.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I got a call from John, this morning,” Fletcher said between drags. “He sounded… not like himself. Worried. You know John. The most laidback man in the world. You only caught him stressed if he missed a putt on the eighteenth. Couldn’t keep him away from that damned golf course. He’s got a son. In Australia, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Another drag. Black waited. No point in hurrying this, though he had to grit his teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“He was definitely not himself. He told me to come over. To his house. He didn’t ask. He fucking "), _c('i', [_vm._v("told.")]), _vm._v(" Then he got angry. Like he was blaming the world for his problems. Started going on about his life, and how shit it was. I said ‘John, you’ve got to calm the hell down’"), _c('i', [_vm._v(".")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He gave Black a sudden hollow, stricken look. “If I had known what he was going to do…”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Another deep drag.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So, I stopped everything. You know how difficult it is to do that in our job. I almost resented him for it. I "), _c('i', [_vm._v("did ")]), _vm._v("resent him for it. As if I’ve got the time to spare. I mean, he’s the one that was retiring. But I did. I dropped everything, got in the car, and drove to his house. It felt like forever. Red lights every hundred yards. Would have been quicker walking. So, I got to his house, and walked up his front path, having to stop myself from tripping up on weeds and shit. He was never a gardener.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Another drag. Smoke coiled about him like shadowy grey tentacles. He stopped, eyes distant.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And then what happened?” asked Black gently.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fletcher focused again, took another smoke. His hand was trembling.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“The front door was open. Just a little. But I thought, "), _c('i', [_vm._v("This is fucking odd.")]), _vm._v(" Who keeps their front door open? And I knew right at that moment that something was bad.” He shook his head. “I shouldn’t have gone in. I shouldn’t have entered his house. Why did I go in?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Another pause.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“But you did go in,” prompted Black.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yes. I did go in. He wasn’t about. I was in his hallway. I shouted for him, but I didn’t get an answer. So, I made my way through to that stupid television room he has. And the first thing I see is that sixty-inch projector television. It takes up a whole side of the room, I swear. Like a fucking cinema screen. Who needs something like that? And it’s dark, because he’s closed his blinds. And so, I turn around… I turn around.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Black waited.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“The silly bastard’s hanging there. I mean fucking "), _c('i', [_vm._v("hanging")]), _vm._v(". Face all twisted. A length of rope round his neck. His tongue was sticking out. His tongue was purple. Fucking purple! His eyes were bulging out their fucking sockets. I can’t get it out my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Black absorbed this information and kept his voice level.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And what did you do, Simon?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He stared fixedly at Black, stubbing out the butt of his cigarette on a saucer improvising as an ashtray; blinked.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I ran the hell out of there and came straight here.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Black stared back, dumbfounded.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You left him there?  Simon, how do you know he was dead? Did you phone for an ambulance?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I know a dead man when I see one,” he mumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Really? And did you phone for an ambulance?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fletcher shook his head, fumbling for another cigarette. Black stretched over and knocked them out of his hand. Fletcher snapped his head up.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“No time for smoking,” said Black, perhaps a little too roughly. “We’re going there now. We’ll take your car. Right now.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f24f9e1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001chapter021.vue
// module id = 135
// module chunks = 0